export default "__VITE_ASSET__DEgyUH01__"